import React from 'react';
import ErrorImg from "../../images/error.jpg";

const ErrorPage = () => {
    return (
        <div className="card" style={{
            backgroundImage: `url(${ErrorImg})`,
            backgroundSize: "cover",
            backgroundPosition: "center center",
            backgroundAttachment: "fixed",
            minHeight: "50vh"
        }}>
            <h2>Sorry no burger here!</h2>
        </div>
    );
};

export default ErrorPage;
